import { render, staticRenderFns } from "./addmedicalservice.vue?vue&type=template&id=8ffd881a&scoped=true&"
import script from "./addmedicalservice.vue?vue&type=script&lang=js&"
export * from "./addmedicalservice.vue?vue&type=script&lang=js&"
import style0 from "./addmedicalservice.vue?vue&type=style&index=0&id=8ffd881a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd881a",
  null
  
)

export default component.exports